import React from 'react';

import styles from './styles.module.scss';
import {TopElement} from '../TopElement';
import {featuresLinks} from '../../../constants/links';
import {Webhook2} from '../../../assets';
import {
  Message1,
  Message2,
  Message3,
  Message4,
  Message5,
  Message6,
} from '../../../assets/icons/antiSpam';

export const AntiSpam = () => {
  return (
    <div className={styles.wrapper}>
      <TopElement
        title="Anti-Spam"
        subTitle="The bot recognises potentially harmful messages such as repeated messages, Zalgo text, and external links. The bot employs the quarantine method, adding suspicious accounts to a list and immediately punishes them when triggered."
        labelTitle="Anti-Spam Tutorial"
        labelLInk={featuresLinks.antiSpam}
      />
      <div className={styles.block}>
        <div className={styles.messagesWrapper}>
          <div className={styles.messageWrapper}>
            <div className={styles.avatar}>
              <Webhook2 />
            </div>
            <div className={styles.message}>
              <Message1 />
              <div className={styles.flag}>🚩</div>
            </div>
          </div>
          <div className={styles.messageWrapper}>
            <div className={styles.avatar}>
              <Webhook2 />
            </div>
            <div className={styles.message}>
              <Message2 />
              {/* <div className={styles.flag}>🚩</div> */}
            </div>
          </div>
          <div className={styles.messageWrapper}>
            <div className={styles.avatar}>
              <Webhook2 />
            </div>
            <div className={styles.message}>
              <Message3 />
              {/* <div className={styles.flag}>🚩</div> */}
            </div>
          </div>
          <div className={styles.messageWrapper}>
            <div className={styles.avatar}>
              <Webhook2 />
            </div>
            <div className={styles.message}>
              <Message4 />
              <div className={styles.flag}>🚩</div>
            </div>
          </div>
          <div className={styles.messageWrapper}>
            <div className={styles.avatar}>
              <Webhook2 />
            </div>
            <div className={styles.message}>
              <Message5 />
              {/* <div className={styles.flag}>🚩</div> */}
            </div>
          </div>
          <div className={styles.messageWrapper}>
            <div className={styles.avatar}>
              <Webhook2 />
            </div>
            <div className={styles.message}>
              <Message6 />
              <div className={styles.flag}>🚩</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
